function AccountsPaymentCtrl($scope, $state, $rootScope, $q, $window, toastr, UserService, AuthService, AppSettings) {
    'ngInject';

    const vm = this;

    $scope.vm = vm;

    vm.isMobile = window.mobilecheck();

    // 결제하기
    vm.submit = function() {
        var IMP = window.IMP;
        IMP.init('imp05378196');

        // IMP.request_pay(param, callback) 호출
        IMP.request_pay({ // param
        //pg: "paypal",
        pay_method: "card",
        merchant_uid: "ORD20180131-0000101",
        name: "테스트",
        amount: 1000,
        buyer_email: "gildong@gmail.com",
        buyer_name: "홍길동",
        buyer_tel: "010-4242-4242",
        buyer_addr: "서울특별시 강남구 신사동",
        buyer_postcode: "01181"
        }, function (rsp) { // callback
        if (rsp.success) {
            // 결제 성공 시 로직,
            console.log(rsp);

            // 이니시스 결제 후 받는 데이터
            /*
            apply_num
            :
            "46441027"
            bank_name
            :
            null
            buyer_addr
            :
            "서울특별시 강남구 신사동"
            buyer_email
            :
            "gildong@gmail.com"
            buyer_name
            :
            "홍길동"
            buyer_postcode
            :
            "01181"
            buyer_tel
            :
            "010-4242-4242"
            card_name
            :
            "BC카드"
            card_quota
            :
            0
            currency
            :
            "KRW"
            custom_data
            :
            null
            imp_uid
            :
            "imp_276550061728"
            merchant_uid
            :
            "ORD20180131-0000101"
            name
            :
            "테스트"
            paid_amount
            :
            1000
            paid_at
            :
            1521781612
            pay_method
            :
            "card"
            pg_provider
            :
            "html5_inicis"
            pg_tid
            :
            "StdpayISP_INIpayTest20180323140650538761"
            pg_type
            :
            "payment"
            receipt_url
            :
            "https://iniweb.inicis.com/DefaultWebApp/mall/cr/cm/mCmReceipt_head.jsp?noTid=StdpayISP_INIpayTest20180323140650538761&noMethod=1"
            status
            :
            "paid"
            success
            :
            true
            */
        } else {
            // 결제 실패 시 로직,
        }
        });
    };

}

export default {
    name: 'AccountsPaymentCtrl',
    fn: AccountsPaymentCtrl
};
